/* eslint-disable max-len */
const BackIcon = ({ colorTheme }: {colorTheme: string}) => {

  const svg = `
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.53033 0.46967C5.23744 0.176777 4.76256 0.176777 4.46967 0.46967L0.46967 4.46967C0.176777 4.76256 0.176777 5.23744 0.46967 5.53033L4.46967 9.53033C4.76256 9.82322 5.23744 9.82322 5.53033 9.53033C5.82322 9.23744 5.82322 8.76256 5.53033 8.46967L2.06066 5L5.53033 1.53033C5.82322 1.23744 5.82322 0.762563 5.53033 0.46967Z"
        fill="${colorTheme}"
      />
    </svg>

  `;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export default BackIcon;
